import type { TabData, NewsTimelinesProps, CurrentYearData } from '../../../components/NewsTimelines/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';

const dateConverter = (published_date: string, locale: string) =>
  new Date(published_date).toLocaleString(`${locale}`, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
const transformNewsTimelines = (data: CMSTransformerDataType): NewsTimelinesProps => {
  const tabsData: TabData[] = [];
  const { aboutAmwayNews, amwayNewsByYear, callBack, year } = data;
  aboutAmwayNews?.forEach((element: CMSTransformerDataType) => {
    tabsData.push({ title: element.year, id: element.year });
  });
  const CurrentNearYearData: CurrentYearData[] = [];
  amwayNewsByYear?.forEach((newsdata: CMSTransformerDataType) => {
    const { image, source, display_title, published_date, locale, link } = newsdata;
    const data = {
      url: image.url,
      source: source,
      description: display_title,
      publishedDate: dateConverter(published_date, locale),
      link: {
        text: link?.text,
        url: link?.url,
        cta: link?.cta,
        target: link?.target,
      },
    };
    CurrentNearYearData.push(data);
  });
  const newsDataByYear = aboutAmwayNews?.find((a: CMSTransformerDataType) => a.year.toString() === year.toString());

  return {
    componentType: 'news_timelines',
    tabsData: tabsData,
    heading: newsDataByYear?.header?.text,
    callBack: callBack,
    currentYearData: CurrentNearYearData,
    year: year,
  };
};
export default transformNewsTimelines;
